import EFPicture from 'elem/compCommon/EFPicture';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoSpace from 'eco-design/base/eco-space';

export default function C() {
    const { useLang, useState, useRouter } = useGlobal();
    const { t } = useLang('Stops');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const cards: any = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760082014382/Frame%201612707035.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1760088895853/H5-Keep%20Food%20Fresh.jpg',
            title: t('img1_title'),
            desc: t('img1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760082013755/Frame%20161269576.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1760088895574/H5-Stay%20Comfortable.jpg',
            title: t('img2_title'),
            desc: t('img2_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760082012234/Frame%20161269575.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1760088897350/H5-Stay%20Connected.jpg',
            title: t('img3_title'),
            desc: t('img3_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760082012395/Frame%201612707037.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1760088896341/H5-Keep%20Essentials%20Running.jpg',
            title: t('img4_title'),
            desc: t('img4_desc'),
        },
    ];

    const onMouseEnter = (k: number) => {
        if (k !== active) {
            setActive(k);
            const target = document.querySelector(`.power-backup-C .card${k} .card-text`) as HTMLUListElement;
            target.style.transition = 'none';
            target.style.opacity = '0';
            setTimeout(() => {
                target.style.transition = 'all 0.4s ease';
                target.style.opacity = '1';
            }, 600);
        }
    };

    return (
        <div id="power-backup-C" className={`power-backup-C  page-layout ${css['power-backup-C']}`}>
            <div className="text-box">
                <p className="title">{t('secC_title')}</p>
            </div>
            <ul className="card-box">
                {cards?.map((card: any, k: number) => (
                    <li className={`card card${k} ${k === active ? 'active' : ''}`} key={k} onMouseEnter={() => onMouseEnter(k)}>
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.title} />
                        </div>
                        <div className="card-text">
                            <p className="card-title">{card?.title}</p>
                            <p className="card-desc">{card?.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>

            <Swiper
                className="swiper-box"
                effect="fade"
                modules={[Scrollbar]}
                spaceBetween={16}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 25,
                    snapOnRelease: true,
                }}
            >
                {cards?.map((item: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="item-img">
                            <EFPicture src={item?.img} srcPad={item?.imgPad} alt={item?.title} />
                        </div>
                        <div className="item-text">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
